import { Record } from 'immutable';
import { LookupAddress } from '../../event/models/lookup-address';

const AgencyLookupSummaryRecord = Record({
  agencyId: null,
  name: null,
  address: new LookupAddress({}),
  manuallyAdded: null
});

export class AgencyLookupSummary extends AgencyLookupSummaryRecord {
  agencyId: string;
  name: string;
  address: LookupAddress;
  manuallyAdded: boolean;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/shared/models/agency-lookup-summary.ts